import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { RootState } from '..';
import { Socket, io } from 'socket.io-client';
import rootGetters from '../getters';
import rootSetters from '../actions';

let axiosInstance: AxiosInstance = axios.create();
let PRINT_SOCKET: Socket;

export const printConnect =
  ([port, ...portList]: number[] = [5151, 5252, 5353]) =>
  (dispatch: DispatchType, _getState: () => RootState) =>
    new Promise<boolean>((resolve) => {
      const {
        print: { setPrint },
      } = rootSetters(dispatch);
      if (!port) {
        setPrint('connected', false);
        resolve(false);
        return;
      }
      axiosInstance
        .get<boolean>(`http://localhost:${port}/easysync-print/ping`)
        .then((response) => {
          PRINT_SOCKET = io(`http://localhost:${port}`, {
            autoConnect: false,
            transports: ['websocket', 'polling'],
          });
          PRINT_SOCKET.connect();
          setPrint('connected', true);
          resolve(response.data);
        })
        .catch(() => {
          dispatch(printConnect(portList));
          setPrint('connected', false);
          resolve(false);
        });
    });

const printActionCreators = (dispatch: <T>(action: any) => T) =>
  Object.assign(
    {},
    {
      PRINT_SOCKET,
      printConnect: () => dispatch<Promise<any>>(printConnect()),
    },
  );
export default printActionCreators;
